export enum InlineNoticeVariantEnum {
	info = 'info',
	warning = 'warning',
	error = 'error',
}
